"use client"

import posthog from "posthog-js"
import { isBrowserAnalyticsBlocked } from "@/lib/analytics/cookies"

type SafeProperty = string | number | boolean | null

type ProductEvent =
  | "game_started"
  | "game_answered"
  | "game_completed"
  | "game_restarted"
  | "daily_started"
  | "daily_answered"
  | "daily_completed"
  | "versus_room_created"
  | "versus_joined"
  | "versus_started"
  | "versus_answered"
  | "versus_completed"
  | "custom_game_created"
  | "custom_game_started"
  | "custom_game_answered"
  | "custom_game_completed"
  | "custom_game_shared"
  | "tool_started"
  | "tool_completed"

export function trackProductEvent(
  event: ProductEvent,
  input: {
    customGameId?: string
    gameTypeId?: string
    properties?: Record<string, SafeProperty>
  } = {},
) {
  if (isBrowserAnalyticsBlocked()) return

  const payload = {
    type: "event" as const,
    event,
    path: window.location.pathname,
    ...input,
  }

  void fetch("/api/analytics/track", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => { /* Analytics must not interrupt gameplay when offline. */ })

  posthog.capture(event, {
    ...input.properties,
    game_type_id: input.gameTypeId,
    custom_game_id: input.customGameId,
  })
}
